import { render, staticRenderFns } from "./classes-begin.vue?vue&type=template&id=451b1aad&scoped=true"
import script from "./classes-begin.vue?vue&type=script&lang=js"
export * from "./classes-begin.vue?vue&type=script&lang=js"
import style0 from "./classes-begin.vue?vue&type=style&index=0&id=451b1aad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b1aad",
  null
  
)

export default component.exports